import React, { useState, useEffect } from 'react';
import { Title, LoadingCard } from '../../Shared';
import { AdminHeader } from '../';
import {
  Container,
  Row,
  Col,
  InputGroup,
  CustomInput,
  Label,
  Button,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { locationActions, locationResultsActions } from '../../_actions';

export function LocationResults() {
  const [locationId, setLocationId] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(locationActions.getAll());
  }, [dispatch]);

  useEffect(() => {
    if (locationId !== 0) {
      dispatch(locationResultsActions.casualTimes(locationId));
    }
  }, [locationId, dispatch]);

  const onDelete = (id) => {
    dispatch(locationResultsActions.deleteTime(id));
  };

  const { locations, loading = false } = useSelector((s) => s.location);
  const { casual, casualLoading } = useSelector((s) => s.locationResults);

  return (
    <>
      <Title text="Manage Results" />
      <AdminHeader goBack title="Manage Casual Results" />
      <Container className="mt-4">
        <Row>
          {loading ? (
            <LoadingCard text="Loading Locations" />
          ) : (
            <Col>
              <InputGroup>
                <CustomInput
                  className="rounded-select"
                  type="select"
                  id="locationId"
                  name="locationId"
                  onChange={(e) => setLocationId(parseInt(e.target.value))}
                  value={locationId}
                  required
                >
                  <option value="0">Select a Location</option>
                  {(locations || []).map((loc) => (
                    <option key={loc.id} value={loc.id}>
                      {loc.name}
                    </option>
                  ))}
                </CustomInput>
              </InputGroup>
            </Col>
          )}
        </Row>
        <Row className="mt-2">
          {casualLoading ? (
            <LoadingCard text="Loading Results" />
          ) : (
            <Col>
              <Label className="mb-2">Delete a recorded time</Label>
              {casual.map(({ id, tsDuration, user }) => {
                return (
                  <TimeEntry key={id}>
                    {user.userName} - {tsDuration}
                    <Button color="primary" onClick={() => onDelete(id)}>
                      Delete
                    </Button>
                  </TimeEntry>
                );
              })}
            </Col>
          )}
        </Row>
      </Container>
    </>
  );
}

const TimeEntry = ({ children }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: '#F2F2F2',
      padding: '0.75rem',
      borderRadius: '1.5rem',
      marginBottom: '0.5rem',
    }}
  >
    {children}
  </div>
);
